export default "__VITE_ASSET__V6dU8p6K__"